module.exports = __webpack_public_path__ + "img/bn0702.7f0db2c0.png";